import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import router from './router';
import * as VueGoogleMaps from 'gmap-vue';
import vuetify from './plugins/vuetify';
import store from './store';
import GmapCluster from 'gmap-vue/dist/components/cluster';
import './styles/index.scss';
import Auth0 from './plugins/auth0';
import { ConfigurationServiceTenantLoader, ITenantLoader, StaticTenantLoader } from '@/common/tenants';
import { AppTheme } from '@/common/AppTheme';

(async (): Promise<void> => {
  let tenantLoader: ITenantLoader;
  const apiUrl = process.env.VUE_APP_CONFIGURATION_API_URL;
  if (apiUrl && apiUrl !== '') {
    console.log('Using configuration service tenant loader');
    tenantLoader = new ConfigurationServiceTenantLoader(apiUrl);
  } else {
    console.log('Using static tenant configuration');
    tenantLoader = new StaticTenantLoader();
  }

  const tenant = await tenantLoader.getTenantForHost(window.location.hostname);
  Vue.prototype.$tenant = tenant;
  Vue.prototype.$theme = new AppTheme(tenant?.themeProperties || {});

  Vue.use(VueGoogleMaps, {
    load: {
      v: 'beta',
      key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
      map_ids: process.env.VUE_APP_GOOGLE_MAPS_STYLE_ID
    }
  });

  Vue.use(Vuex);

  Vue.component('GmapCluster', GmapCluster);

  Vue.use(Auth0, {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    organizationId: tenant?.externalId,
    onRedirectCallback: (appState: any) => {
      router.push(appState?.targetUrl ?? window.location.pathname);
    }
  });

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
  }).$mount('#app');
})();
